import { Contest, ContestPhase, DesignContest } from '../global';

// //OBSOLETA
// export function dateColor(contest: Contest): string {
//   const status = computeContestStatus(contest);
//   switch (status) {
//     case 'closed':
//       return 'danger';
//     case 'ongoing':
//       return 'success';
//     case 'client-vote':
//       return 'dark_yellow';
//     case 'community-vote':
//       return 'dark_yellow';
//     case 'coming-soon':
//       return 'light_grey_40';
//     case 'ERROR':
//       return 'error';
//     default:
//       return 'black';
//   }
// }

// //OBSOLETA
// export function contestPhaseString(contest: Contest) {
//   const status = computeContestStatus(contest);
//   return status.replace('-', ' ');
// }

// //OBSOLETA
// export function contestPhaseExplanation(contest: Contest) {
//   const status = computeContestStatus(contest);
//   switch (status) {
//     case 'closed':
//       return `Closed: ${localizedDateString(contest.closeDate)}`;
//     case 'coming-soon':
//       return `Starts: ${localizedDateString(contest.startDate)}`;
//     case 'upload-phase':
//       return `Ends: ${localizedDateString(contest.endUploadDate)}`;
//     case 'client-vote':
//       return ``;
//     case 'community-vote':
//       return `Ends: ${localizedDateString(contest.endVotingDate)}`;
//     default:
//       return 'UNKNOWN';
//   }
// }

//NEW
export function hasCommunityVote(contest: Contest | DesignContest): boolean {
  return contest.endVotingDate != null && new Date(contest.endUploadDate).getTime() < new Date(contest.endVotingDate).getTime() && !contest.isPrivate && !contest.hideGalleryTab;
}
export function contestPhaseString(contest: Contest) {
  const status = computeContestPhase(contest);
  return status.replace('-', ' ');
}

//NEW
export function computeContestPhase(contest: Contest |DesignContest): ContestPhase {
  if (contest.isCoCreation) {
    return 'ERROR';
  }
  if (contest.isClosed) {
    return 'closed';
  }
  const date = new Date().getTime();
  if (date < new Date(contest.startDate).getTime()) {
    return 'coming-soon';
  } else if (date < new Date(contest.endUploadDate).getTime()) {
    return 'upload-phase';
  } else if (hasCommunityVote(contest) && date < new Date(contest.endVotingDate).getTime()) {
    return 'community-vote';
  } else {
    return 'client-vote';
  }
}
//NEW
export function dateStringForContest(contest: Contest): string {
  const phase = computeContestPhase(contest);
  return dateStringForPhase(phase, contest);
}
//NEW
export function dateStringForPhase(phase: ContestPhase, contest: Contest): string {
  console.log(contest);
  switch (phase) {
    case 'closed':
      return `Closed: ${localizedDateString(contest.assignmentDate)}`;
    case 'coming-soon':
      return `Starts: ${localizedDateString(contest.startDate)}`;
    case 'upload-phase':
      return `Ends: ${localizedDateString(contest.endUploadDate)}`;
    case 'client-vote':
      return `Client Vote`;
    case 'community-vote':
      return `Ends: ${localizedDateString(contest.endVotingDate)}`;
    default:
      return 'error';
  }
}
//NEW
export function dateColorForPhase(phase: ContestPhase): string {
  switch (phase) {
    case 'closed':
      return 'danger';
    case 'upload-phase':
      return 'success';
    case 'client-vote':
      return 'dark_yellow';
    case 'community-vote':
      return 'dark_yellow';
    case 'coming-soon':
      return 'light_grey_40';
    case 'ERROR':
      return 'error';
    default:
      return 'black';
  }
}

export function Datestr(date: string) {
  return new Date(date).getTime();
}

export function phaseProgress(contest: Contest): number {
  const date = Math.trunc(Datestr(new Date().toISOString()) / 86400000);
  const endDateNumber = Math.trunc(Datestr(contest.endUploadDate) / 86400000);

  const phase = computeContestPhase(contest);
  if (phase === 'upload-phase') {
    const startDateNumber = Math.trunc(Datestr(contest.startDate) / 86400000);
    let tot = endDateNumber - startDateNumber;
    let passed = date - startDateNumber;
    return (passed * 100) / tot;
    // console.log(tot, passed, progressNumber);
  } else if (phase === 'community-vote') {
    const endVotingDateNumber = Math.trunc(Datestr(contest.endVotingDate) / 86400000);
    let tot = endVotingDateNumber - endDateNumber;
    let passed = date - endDateNumber;
    return (passed * 100) / tot;
  }
  return 100;
}

// export function computeContestStatus(contest: Contest): ContestStatus {
//   if (contest.isCoCreation) {
//     return 'ERROR';
//   }
//   if (contest.isClosed) {
//     return 'closed';
//   }
//   const date = new Date().getTime();
//   if (date < new Date(contest.startDate).getTime()) {
//     return 'coming-soon';
//   } else if (date < new Date(contest.endUploadDate).getTime()) {
//     return 'upload-phase';
//   } else if (hasCommunityVote(contest) && date < new Date(contest.endVotingDate).getTime()) {
//     return 'community-vote';
//   } else {
//     return 'client-vote';
//   }
// }

function uploadDuration(contest: Contest): number {
  return Math.trunc((new Date(contest.endUploadDate).getTime() - new Date(contest.startDate).getTime()) / 86400000);
}
function passedUpload(contest: Contest): number {
  return Math.trunc((new Date().getTime() - new Date(contest.startDate).getTime()) / 86400000);
}

export function timelineInfo(contest: Contest) {
  var result = { uploadActive: false, clientVoteActive: false, communityVoteActive: false, closed: false, stateProgress: 0, targetSeconds: undefined as number | undefined };
  const status = computeContestPhase(contest);
  switch (status) {
    case 'closed':
      result.closed = true;
      result.stateProgress = 100;
      break;
    case 'upload-phase':
      result.uploadActive = true;
      result.stateProgress = (passedUpload(contest) / uploadDuration(contest)) * 100;
      result.targetSeconds = new Date(contest.endUploadDate).getTime() / 1000;
      break;
    case 'client-vote':
      result.clientVoteActive = true;
      result.stateProgress = 50;
      break;
    case 'community-vote':
      result.communityVoteActive = true;
      break;
    default:
      console.log('status not found: ' + status);
      break;
  }
  return result;
}

export const localizedDateString = (dateString?: string) => {
  if (dateString) {
    var startDate: Date = new Date(Date.parse(dateString));
    return startDate.toLocaleDateString('en', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  }
};
